var Handlebars = require("C:\\Repositories\\bn_dist87_monzabon.at\\Build\\node_modules\\handlebars\\runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.roomtypes : depth0),{"name":"each","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {});

  return "        <div class=\"bn-room-rates bn-room-rates--header-"
    + alias2(alias1(((stack1 = ((stack1 = ((stack1 = ((stack1 = (data && data.root)) && stack1.trans)) && stack1.layout)) && stack1.header)) && stack1.type), depth0))
    + " eh-rates\" data-asa-code=\""
    + alias2(((helper = (helper = helpers.asacode || (depth0 != null ? depth0.asacode : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias3,{"name":"asacode","hash":{},"data":data}) : helper)))
    + "\" "
    + ((stack1 = helpers.each.call(alias3,(depth0 != null ? depth0.roomtypeboards : depth0),{"name":"each","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + " data-price-type=\""
    + alias2(alias1(((stack1 = ((stack1 = ((stack1 = ((stack1 = ((stack1 = (data && data.root)) && stack1.trans)) && stack1.ehotelier)) && stack1.configs)) && stack1.price_list_all)) && stack1.type), depth0))
    + "\" data-slideable=\"false\">\r\n            <div class=\"bn-loader\">\r\n                <i class=\"bn-icon bn-icon--loader\"></i>\r\n            </div>\r\n            <div class=\"bn-no-result hidden\">\r\n                "
    + alias2(alias1(((stack1 = ((stack1 = ((stack1 = (data && data.root)) && stack1.trans)) && stack1["default"])) && stack1.no_entries), depth0))
    + "\r\n            </div>\r\n        </div>\r\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = (helpers["if--equals"] || (depth0 && depth0["if--equals"]) || helpers.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.isdefault : depth0),true,{"name":"if--equals","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"4":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "data-board-code=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.board : depth0)) != null ? stack1.code : stack1), depth0))
    + "\"";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.records : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./source/hbs/ehotelier/room/price-overview.hbs
// module id = 293
// module chunks = 0